module.exports = {
      id: "ic-marketbear-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-marketbear-usage",
      toString: function () {
        return this.url;
      }
    }